export const isStoreSelectionMissing = value => (
  !value || value === 'none' || (typeof value === 'string' && value.trim() === '')
);
